'use strict';


/*
From: Angular tabs - sortable/moveable (stackoverflow)
       http://stackoverflow.com/a/23443028/1309218
       http://plnkr.co/edit/Xj4v3f5Id9UcW5WSlxDG?p=preview

*/

angular.module('paizacloudApp')
  .directive('sortableTab', function() {
    return {
      // template: '<div></div>',
      restrict: 'EA',
      link: function(scope, element, attrs) {
        // Attempt to integrate with ngRepeat
        // https://github.com/angular/angular.js/blob/master/src/ng/directive/ngRepeat.js#L211
        // var match = attrs.ngRepeat.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
        var match = attrs.ngRepeat.match(/^\s*([\s\S]+?)\s+in\s+([^|]+?)(?:\s+track\s+by\s+([^|]+?))?\s*(\|.*)?$/);


        var tabs;
        scope.$watch(match[2], function(newTabs) {
          tabs = newTabs;
        });

        var index = scope.$index;
        scope.$watch('$index', function(newIndex) {
          index = newIndex;
        });

        var model = scope[match[1]];

        attrs.$set('draggable', true);
        /* <a href> is invalid and not draggable on Safari, it should be <a href="#" */
        element.find(".nav-link").attr("href", "#");

        // Wrapped in $apply so Angular reacts to changes
        var wrappedListeners = {
          // On item being dragged
          dragstart: function(e) {
            console.log("dragstart", e);
            var dataTransfer = e.originalEvent.dataTransfer;

            dataTransfer.effectAllowed = 'move';
            dataTransfer.dropEffect = 'move';
            // dataTransfer.setData('application/json', index);
            dataTransfer.setData('application/json', {index: index, model: model});
            element.addClass('dragging');
            //e.preventDefault();
            // e.stopPropagation();
          },
          dragover: function(e){
            console.log("dragover", e);
            e.preventDefault();
          },
          dragend: function(e) {
            //e.stopPropagation();
            console.log("dragend", e);
            element.removeClass('dragging');
          },

          // On item being dragged over / dropped onto
          dragenter: function(e) {
            console.log("dragenter", e);
            //element.addClass('dropping');
          },
          dragleave: function(e) {
            console.log("dragleave", e);
            element.removeClass('hover');
            //element.removeClass('dropping');
          },
          drop: function(e) {
            console.log("drop", e);
            e.preventDefault();
            e.stopPropagation();

            /*
            var dataTransfer = e.originalEvent.dataTransfer;
            var sourceIndex = dataTransfer.getData('application/json');
            move(sourceIndex, index);
            */

            var dataTransfer = e.originalEvent.dataTransfer;
            var sourceData = dataTransfer.getData('application/json');
            var sourceModel = sourceData.model;

            var sourceIndex = tabs.indexOf(sourceModel);
            var destIndex = tabs.indexOf(model);

            move(sourceIndex, destIndex);

            element.removeClass('hover');
          }
        };

        // For performance purposes, do not
        // call $apply for these
        var unwrappedListeners = {
          dragover: function(e) {
            e.preventDefault();
            element.addClass('hover');
          },
          /* Use .hover instead of :hover. :hover doesn't play well with
             moving DOM from under mouse when hovered */
          mouseenter: function() {
            element.addClass('hover');
          },
          mouseleave: function() {
            element.removeClass('hover');
          }
        };


        angular.forEach(wrappedListeners, function(listener, event) {
          element.on(event, wrap(listener));
        });


        angular.forEach(unwrappedListeners, function(listener, event) {
          element.on(event, listener);
        });

        function wrap(fn) {
          return function(e) {
            scope.$apply(function() {
              fn(e);
            });
          };
        }

        function move(fromIndex, toIndex) {
          // http://stackoverflow.com/a/7180095/1319998
          tabs.splice(toIndex, 0, tabs.splice(fromIndex, 1)[0]);
        }

      }
    };
  });
